import {
  type VolumeItem,
  VolumeMountTab,
  isVolumeClaimTemplateItem,
  isVolumeStorageItem,
} from '../../../capabilities/container-storage/volumeTypes';
import { resolveStorageClassSubmitValue } from '../../../components/storageClassField';
import { serializeContainerGpu } from './gpuForm';

export function serializeContainerSystemVolume(systemDiskSize: number | undefined) {
  if (!(systemDiskSize && systemDiskSize > 0)) return undefined;
  return {
    name: 'image',
    reclaimPolicy: 'Delete',
    size: {
      request: `${systemDiskSize}Gi`,
      limit: `${systemDiskSize}Gi`,
    },
    type: 'System',
  };
}

export function serializeContainerDataVolumes(volumes: VolumeItem[] | undefined) {
  if (!volumes?.length) return [];

  return volumes
    .map((item) => {
      const mountPath = item.volumeMounts?.[0]?.mountPath;
      const reclaimPolicy = item.reclaimPolicy;

      if (isVolumeClaimTemplateItem(item)) {
        return {
          type: 'Data',
          name: String(item.volumeName ?? '').trim(),
          mountPath,
          reclaimPolicy: reclaimPolicy ?? 'Delete',
          accessModes: item.accessModes,
          storageclass: resolveStorageClassSubmitValue(item.storageClass, item.pricing),
          size: item.volumeCapacity
            ? {
                request: `${item.volumeCapacity}Gi`,
                limit: `${item.volumeCapacity}Gi`,
              }
            : undefined,
          source: {
            type: 'PersistentVolumeClaimTemplate',
          },
        };
      }

      if (isVolumeStorageItem(item) && item.type === VolumeMountTab.PERSISTENCE) {
        return {
          type: 'Data',
          name: String(item.volumeName ?? '').trim(),
          mountPath,
          reclaimPolicy: reclaimPolicy ?? 'Delete',
          source: {
            type: 'PersistentVolumeClaim',
            claimName: item.selected,
          },
        };
      }

      return null;
    })
    .filter((item): item is NonNullable<typeof item> => Boolean(item));
}

export { serializeContainerGpu };
